import { videos } from "@/mocks/videos";
import { categories } from "@/mocks/categories";

export function formatViews(views: number): string {
  if (views >= 100000000) {
    return `${(views / 100000000).toFixed(1)}亿`;
  }
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
}

export function durationToSeconds(duration: string): number {
  const parts = duration.split(":").map((p) => Number(p));
  if (parts.length === 2) return parts[0] * 60 + parts[1];
  if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  return 0;
}

export function getCategoryBySlug(slug: string) {
  return categories.find((item) => item.slug === slug);
}

export function getCategoryName(slug: string): string {
  return getCategoryBySlug(slug)?.name ?? "全部视频";
}

export function getVideoById(id: string) {
  return videos.find((item) => item.id === id);
}

export function getRelatedVideos(id: string, category: string, tags: string[]) {
  const current = getVideoById(id);
  const scored = videos
    .filter((item) => item.id !== id)
    .map((item) => {
      let score = 0;
      if (item.category === category) score += 3;
      score += item.tags.filter((tag) => tags.includes(tag)).length * 2;
      if (current && item.author === current.author) score += 1;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.views - a.item.views);
  return scored.map((entry) => entry.item).slice(0, 6);
}